import { h, defineComponent } from 'vue';
import { pageSubtitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { numberInput } from '@/ui/components/form/NumberInput';
import { getOrganizationUsersCount } from '@/ui/auth/auth';
import { numberSeats } from '@/services/chargebee/availablePlans';

export const CbSelectUsers = defineComponent({
  name: 'CbSelectUsers',
  setup() {
    const minNumberSeats = getOrganizationUsersCount();

    return function render() {
      return h('div', { class: 'subscribe_page__users-row' }, [
        pageSubtitle(t('subscription.select-number-users')),
        numberInput({
          value: numberSeats.value,
          min: minNumberSeats,
          controlsRounded: true,
          controlsPosition: 'compact',
          size: 'is-small',
        }, v => {
          if (v < minNumberSeats) {
            numberSeats.value = minNumberSeats;

            return;
          }

          numberSeats.value = v;
        }),
      ]);
    };
  },
});
